import { Badge } from "@/components/ui/badge";
import { Check, X, HelpCircle, CalendarCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { format } from "date-fns";

interface RsvpStatusBadgeProps {
  status: string | null;
  rsvpAt?: string | null;
  className?: string;
}

export function RsvpStatusBadge({ status, rsvpAt, className }: RsvpStatusBadgeProps) {
  if (!status) return null;

  const config = {
    ACCEPTED: {
      label: "Accepted",
      icon: Check,
      className: "bg-green-500/20 text-green-400 border-green-500/30",
    },
    DECLINED: {
      label: "Declined",
      icon: X,
      className: "bg-red-500/20 text-red-400 border-red-500/30",
    },
    TENTATIVE: {
      label: "Tentative",
      icon: HelpCircle,
      className: "bg-yellow-500/20 text-yellow-400 border-yellow-500/30",
    },
  }[status.toUpperCase()];

  if (!config) return null;

  const Icon = config.icon;
  const formattedTime = rsvpAt ? format(new Date(rsvpAt), "MMM d 'at' h:mm a") : null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className={cn(
              "gap-1 text-xs font-medium cursor-default",
              config.className,
              className
            )}
          >
            <Icon className="h-3 w-3" />
            {config.label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <div className="flex items-center gap-1.5 text-xs">
            <CalendarCheck className="h-3 w-3" />
            <span>Calendar RSVP {formattedTime ? `received ${formattedTime}` : 'response'}</span>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
